(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["modal-banner-t4e"] && !Shopify.designMode) return;
  try {
    
    const btnClose = document.querySelector("[data-button-modalt4e-close]");
    const modal = document.querySelector("[data-baner-modalt4e]");
    const wasActive = getCookie('modalt4e-close');
  const isConsent = getCookie('cookie-consent');

      function setCookie(name, value, days) {
      let expires = "";
      if (days) {
          const date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

    function getCookie(name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
  }

    if(wasActive === 'true') {
      modal.classList.remove('isActive');
    } else{
    modal.classList.add('isActive');
    }

    btnClose.addEventListener('click', () => {
      btnClose.parentNode.remove();
      setCookie('modalt4e-close', 'true', 3);
    })

  } catch(e) { console.error(e); }
})();
})();
